<template>
  <div>
    <section id="page-top" style="padding: 0px;"/>
    <HeroSection />
    <FeaturesSection />
    <DownloadSection />
    <TestimonialsSection />
  </div>
</template>

<script>
import HeroSection from '../sections/home/HeroSection.vue'
import FeaturesSection from '../sections/home/FeaturesSection.vue'
import TestimonialsSection from '../sections/home/TestimonialsSection.vue'
import DownloadSection from '../sections/home/DownloadSection.vue'

export default {
  name: 'Home',
  components: {
    HeroSection,
    FeaturesSection,
    DownloadSection,
    TestimonialsSection
  }
}
</script>
